import { gql } from "@apollo/client";

export const MARKETING_QUERY = gql`
    query Marketing (
        $filters: SalesFilterInput
    ) {
        shareOfVoices (filter: $filters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        brandAwarenesses (filter: $filters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        marketSharePcts (filter: $filters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        customerAcquisitionCosts (filter: $filters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        customerLifetimeValues (filter: $filters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        netPromoterScores (filter: $filters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        
        
        marketingSpendByRanges {
            items {
                mtdPct
                mtdValue
                qtdPct
                qtdValue
                spendRange
                ytdPct
                ytdValue
            }
        }
        websiteTrafficBySources {
            items {
                mtdPct
                mtdValue
                qtdPct
                qtdValue
                trafficSourceName
                ytdPct
                ytdValue
            }
        }
        customerAcquisitionCosts (filter: $filters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        impressionsByRegions {
            items {
                mtdPct
                mtdValue
                qtdPct
                qtdValue
                regionName
                ytdPct
                ytdValue
            }
        }
        impressionsByStates {
            items {
                mtdValue
                qtdValue
                stateCode
                stateName
                ytdValue
            }
        }
        cacBreakdownByChannels {
            items {
                channelName
                mtdPct
                mtdValue
                qtdPct
                qtdValue
                ytdPct
                ytdValue
           }
        }
        impressionsTop10Campaigns {
            items {
                campaignName
                channelName
                mtdValue
                qtdValue
                ytdValue
            }
        }
        impressionsByChannelOverTime {
            items {
                month
                channels {
                    channel
                    impressionValue
                }
            }
        }







    }
`;

